import React, { useState, useEffect } from 'react';
import {
  Button,
  Tooltip,
  Modal,
  Select,
  InputNumber,
  Radio
} from 'antd';
import {
  ThunderboltOutlined,
  UpCircleOutlined,
  DownCircleOutlined, ExclamationCircleFilled, ToolOutlined
} from '@ant-design/icons';
import './GlobalFloatButton.scss';
import { postData } from '../../service/APIClient';
import { URL_LABELS } from '../../service/endpoints';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNotification } from '../../Helper/NotificationProvider';
import store from '../../store';
import { patchLocation } from '../../slices/locationSlice';
import { patchEvent } from '../../slices/eventSlice';
import TemplatePreview from '../TemplatePreview/TemplatePreview';
const { confirm } = Modal;


const { Option } = Select;

const GlobalFloatButton = () => {
  const [expanded, setExpanded] = useState(false);
  const { openNotification, contextHolder } = useNotification();
  const [flashModalVisible, setFlashModalVisible] = useState(false);
  const [flashColor, setFlashColor] = useState('RED');
  const [flashDuration, setFlashDuration] = useState(5);
  const [durationType, setDurationType] = useState('seconds');
  const { t } = useTranslation();
  const customers = useSelector(state => state.customers.data);
  const user = store.getState().auth.user;
  const templates = useSelector(state => state.templates.data);
  const locations = useSelector(state => state.locations.data);
  const events = useSelector(state => state.events.data);
  const dispatch = useDispatch();
  const selectedCustomer = store.getState().customers.selectedCustomer || user?.tenantId;
  const customer = customers.find(customer => customer.key === selectedCustomer);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const handleFlash = () => {
    postData(`${URL_LABELS}/flash/all`, {
      color: flashColor,
      duration: flashDuration
    });
  };

  const handleReset = () => {
    let selectedTemplate = null;
    let modalInstance = null;

    // Create a custom component for the modal content to handle state properly
    const ResetModalContent = () => {
      const [localSelectedTemplate, setLocalSelectedTemplate] = useState(null);
      
      const handleTemplateChange = (value, option) => {
        selectedTemplate = option.label;
        setLocalSelectedTemplate(option.label);
        modalInstance.update({ okButtonProps: { disabled: false } });
      };

      const template = templates?.find(template => template?.name === localSelectedTemplate);

      return (
        <div>
          <p>
            {`Sepioo Location "${customer.sepiooLocation}" zurücksetzen auf:`}
          </p>

          <Select
            style={{ minWidth: 170, marginBottom: 10 }}
            showSearch
            placeholder="Template auswählen"
            onChange={handleTemplateChange}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={[
              ...new Map(templates?.filter(template => template?.locations?.includes(customer.sepiooLocation))
                .map((item) => [item.name, item])).values()
            ].map((item) => ({
              value: item.id,
              label: item.name
            }))}
          />

          {template && (
            <div style={{ marginTop: '10px' }}>
              <TemplatePreview
                templateName={template.name}
                sourceCode={template.sourceCode}
              />
            </div>
          )}
        </div>
      );
    };

    modalInstance = Modal.confirm({
      title: 'Alle Labels zurücksetzen',
      icon: <ExclamationCircleFilled />,
      content: <ResetModalContent />,
      okText: 'Bestätigen',
      okType: 'danger',
      okButtonProps: { disabled: true },
      cancelText: 'Abbrechen',
      width: 400,
      async onOk() {
        try {
          if (!selectedTemplate) {
            return;
          }
          await postData(`${URL_LABELS}/reset/all`, {
            template: selectedTemplate,
          });

          for (const event of events) {
            const updatedGuestList = event?.guestList.map((guest) => {
              return {
                ...guest,
                name: "",
                surname: "",
                title: "",
                companyInfo: "",
                message: "",
                matching: {
                  ...guest.matching,
                  template: selectedTemplate
                }
              };
            });

            await dispatch(patchEvent({
              eventId: event.key,
              changes: {
                guestList: updatedGuestList
              }
            }))
          }

          openNotification(
            'bottomRight',
            'Labels zurückgesetzt',
            `Alle Labels der Sepioo Location "${customer.sepiooLocation}" wurden auf Template ${selectedTemplate} zurückgesetzt`,
            true
          );
        } catch (err) {
          console.error(err);
          openNotification(
            'bottomRight',
            'Fehlgeschlagen',
            `Fehler beim Wechseln der Labels bei Sepioo Location "${customer.sepiooLocation}".`,
            false
          );
        }
      },
    });
  };

  const handleFlashRightClick = e => {
    e.preventDefault();
    setFlashModalVisible(true);
  };

  const handleModalOk = () => {
    setFlashModalVisible(false);
  };

  const handleModalCancel = () => {
    setFlashModalVisible(false);
  };

  const displayDuration = `${flashDuration}${durationType === 'minutes' ? 'm' : 's'}`;

  const colorOptions = {
    WHITE: 'white',
    RED: 'lightcoral',
    GREEN: 'lightgreen',
    BLUE: 'lightblue',
    YELLOW: 'lightgoldenrodyellow',
    CYAN: 'lightcyan',
    MAGENTA: 'lightpink'
  };

  return (
    <>
      {contextHolder}
      <div className="global-float-button">
        <Button
          type="primary"
          shape="circle"
          icon={expanded ? <DownCircleOutlined /> : <UpCircleOutlined />}
          size="large"
          style={{ backgroundColor: '#000000', color: '#fff' }}
          onClick={toggleExpanded}
          className="main-float-button"
        />

        {expanded && (
          <div className="action-buttons">
            <Tooltip title={`Blinken (${displayDuration})`} placement="left">
              <Button
                type="default"
                shape="circle"
                icon={<ThunderboltOutlined />}
                size="large"
                className="action-button"
                style={{
                  backgroundColor: colorOptions[flashColor],
                  color: '#000'
                }}
                onClick={handleFlash}
                onContextMenu={handleFlashRightClick} // Right-click for additional options
              />
            </Tooltip>

            {/*<Tooltip title="Zurücksetzen" placement="left">*/}
            {/*  <Button*/}
            {/*    type="default"*/}
            {/*    shape="circle"*/}
            {/*    icon={<RedoOutlined />}*/}
            {/*    size="large"*/}
            {/*    className="action-button"*/}
            {/*    onClick={() => handleReset("Wartung")}*/}
            {/*  />*/}
            {/*</Tooltip>*/}

            <Tooltip title="Zurücksetzen" placement="left">
              <Button
                type="default"
                shape="circle"
                icon={<ToolOutlined />}
                size="large"
                className="action-button"
                onClick={() => handleReset()}
              />
            </Tooltip>

            {/*<Tooltip title="Refresh">*/}
            {/*  <Button*/}
            {/*    type="default"*/}
            {/*    shape="circle"*/}
            {/*    icon={<SyncOutlined />}*/}
            {/*    size="large"*/}
            {/*    className="action-button"*/}
            {/*    onClick={handleRefresh}*/}
            {/*  />*/}
            {/*</Tooltip>*/}
          </div>
        )}

        <Modal
          title="Blinkeinstellungen"
          visible={flashModalVisible}
          onOk={handleModalOk}
          onCancel={handleModalCancel}
          cancelText={"Abbrechen"}
        >
          <div style={{ marginBottom: 16 }}>
            <span>Farbe: </span>
            <Select
              defaultValue={flashColor}
              onChange={value => setFlashColor(value)}
              style={{ width: 120 }}
            >
              <Option value="WHITE">Weiß</Option>
              <Option value="RED">Rot</Option>
              <Option value="GREEN">Grün</Option>
              <Option value="BLUE">Blau</Option>
              <Option value="YELLOW">Gelb</Option>
              <Option value="CYAN">Türkis</Option>
              <Option value="MAGENTA">Magenta</Option>
            </Select>
          </div>

          <div style={{ marginBottom: 16 }}>
            <span>Dauer: </span>
            <InputNumber
              min={1}
              max={60}
              value={flashDuration}
              onChange={setFlashDuration}
              style={{ width: 120 }}
            />
          </div>

          <div>
            <Radio.Group
              value={durationType}
              onChange={e => setDurationType(e.target.value)}
            >
              <Radio.Button value="seconds">Sekunden</Radio.Button>
              <Radio.Button value="minutes">Minuten</Radio.Button>
            </Radio.Group>
          </div>
        </Modal>
      </div>
    </>

  );
};

export default GlobalFloatButton;
